var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"btn btn-light",class:_vm.activeClass,attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.editorParams.commands[_vm.command](_vm.args)}}},[_vm._t("default",function(){return [_c('i',{staticClass:"fas fa-fw",class:_vm.iconClass})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }